import SimpleTmpl from '@Services/SimpleTmpl';
import { RxSocketUrls } from '@Constants/CommonConstants';
import uuid from 'uuid/v4';
import { DEFAULT_FIRST_ITEM, DEFAULT_LAST_ITEM } from '@Services/Results/const';
import RxSocket from '@Services/RxSocket';

export const getSimilar = (id, databaseId, structure, channel, dbs) => {
  let payload;

  if (structure) {
    payload = {
      structure,
    };
  } else {
    payload = {
      id,
      databaseId,
    };

    if (dbs) {
      payload.databases = dbs;
    }
  }

  return RxSocket.send(channel, payload);
};

export const getContextInfo = (context, id, databaseId, searchId, channel) => {
  return RxSocket.send(channel, {
    idList: [id],
    databases: [databaseId],
    context,
    searchId,
  });
};

export const cancelSearch = (searchId) => {
  return RxSocket.send(SimpleTmpl.format(RxSocketUrls.CancelSearch, { searchId }), {});
};

export const getResultsById = (
  resultName,
  databaseId,
  context,
  // eslint-disable-next-line default-param-last
  firstItem = DEFAULT_FIRST_ITEM,
  // eslint-disable-next-line default-param-last
  lastItem = DEFAULT_LAST_ITEM,
  sort,
  order,
  hitSetKey,
  requestId,
  similarityMol,
  isHeatmapCellDetails,
  coResults,
  forPlanner,
  combinedResponse,
  filterApplied
) => {
  const endpointUrl = isHeatmapCellDetails ? RxSocketUrls.ChannelsUrls.heatmap.detailsList : RxSocketUrls.ResultsUrl;
  const newRequestParam = {
    resultName,
    databaseId,
    context,
    firstItem,
    lastItem,
    hitSetKey,
    forPlanner,
    combinedResponse,
    filterApplied,
  };

  // Check if param sort is passed, because the BE return errors if we pass empty sort or order params
  if (sort) {
    newRequestParam.sort = sort;
  }
  if (order) {
    newRequestParam.order = order;
  }
  if (similarityMol) {
    newRequestParam.similarityMol = similarityMol;
  }
  if (coResults) {
    newRequestParam.coResults = coResults;
  }
  newRequestParam.requestId = requestId || uuid();

  RxSocket.send(endpointUrl, newRequestParam);
  return String(newRequestParam.requestId);
};
